import angular from 'angular';

import { LoginService } from './login.service';
import userHandler from './../user-handler.module';
import { loginInitializer } from '../../../common/directives/login-initializer/login-initializer.directive';
const MODULE_NAME = 'loginService';

export default angular.module(MODULE_NAME, [userHandler])
    .service('loginService', LoginService)
    .directive('loginInitializer', loginInitializer).name;


